import * as React from 'react';
import Tab from '@material-ui/core/Tab';

const CustomTab = (props) => {
    return <Tab {...props} />;
};

export { CustomTab as Tab };
